import * as Yup from 'yup';

import { SERVICE_FEE_TYPE } from 'constants/flightBooking';
import { parseCurrencyInputToNumber } from 'utils/currencyFormat';

const hasAtMostTwoDecimals = (value) => (
  value === undefined || Math.abs(value * 100 - Math.round(value * 100)) < 1e-9
);

// Mirrors BE FlightSetting validation (contract-decisions.md, "Markup rules").
const feeShape = {
  type: Yup.string()
    .oneOf(Object.values(SERVICE_FEE_TYPE), 'Loại phí không hợp lệ')
    .required('Loại phí là bắt buộc'),
  value: Yup.number()
    // Form input arrives as a Vietnamese-formatted string ("50.000", "5,5").
    .transform((value, originalValue) => (
      typeof originalValue === 'string' ? parseCurrencyInputToNumber(originalValue) : value
    ))
    .typeError('Giá trị phải là số')
    .required('Giá trị là bắt buộc')
    .when('type', {
      is: SERVICE_FEE_TYPE.PERCENT,
      then: Yup.number()
        .moreThan(0, 'Phần trăm phải lớn hơn 0')
        .max(100, 'Phần trăm tối đa là 100')
        .test('max-two-decimals', 'Tối đa 2 chữ số thập phân', hasAtMostTwoDecimals),
      otherwise: Yup.number()
        .integer('Số tiền phải là số nguyên')
        .min(0, 'Số tiền không được âm'),
    }),
};

const flightSettingValidationSchema = Yup.object({
  serviceFee: Yup.object(feeShape),
  perAirline: Yup.array()
    .of(Yup.object({
      code: Yup.string().required('Hãng là bắt buộc'),
      ...feeShape,
    }))
    .test('unique-codes', 'Mỗi hãng chỉ được cấu hình một lần', (list = []) => (
      new Set(list.map((item) => item.code)).size === list.length
    )),
});

export default flightSettingValidationSchema;
